/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `carrier` - Transportator
 * * `shipper` - Expeditor
 * * `carrier_and_shipper` - Transportator și expeditor
 */
export enum ContractorActivityTypeEnum {
  CARRIER = 'carrier',
  SHIPPER = 'shipper',
  CARRIER_AND_SHIPPER = 'carrier_and_shipper',
}
